import { render } from "./ls.vue?vue&type=template&id=5cccbfc2"
import script from "./ls.vue?vue&type=script&lang=js"
export * from "./ls.vue?vue&type=script&lang=js"

import exportComponent from "D:\\shiv_mfg_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__